import KoobInputSegmented from '@koob/ui/src/components/KoobInputSegmented';
import {
  useItineraryPinLevel,
  useSearchHotels,
  useSetItineraryPinLevel,
  useSetSearchHotels,
} from '../../hooks/useTripStoreSelectors';

const PIN_LEVELS = [0, 1, 2];

// Itinerary mode: hotels on or off, and how many pin levels show.
export default function TripFilterItinerary({
  t,
}: {
  t: (key: string) => string;
}) {
  const searchHotels = useSearchHotels();
  const setSearchHotels = useSetSearchHotels();
  const pinLevel = useItineraryPinLevel();
  const setPinLevel = useSetItineraryPinLevel();

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <KoobInputSegmented
        value={searchHotels}
        onChange={(value: boolean) => setSearchHotels(value)}
        options={[
          {
            value: false,
            label: (
              <div className="text-sm">
                <i className="fa fa-xmark mr-1" />
                Hide hotels
              </div>
            ),
          },
          {
            value: true,
            label: (
              <div className="text-sm">
                <i className="fa fa-hotel mr-1" />
                Show hotels
              </div>
            ),
          },
        ]}
      />

      <KoobInputSegmented
        value={pinLevel}
        onChange={(value: number) => setPinLevel(value)}
        options={PIN_LEVELS.map((level) => ({
          value: level,
          label: (
            <div className="text-sm text-center leading-tight">
              <i className="fa fa-map-pin mr-1.5" />
              {level + 1}
              <br />
              <span className="text-xs">
                {t(`itinerary.pinLevel${level + 1}`)}
              </span>
            </div>
          ),
        }))}
      />
    </div>
  );
}
